import {
  Button,
  List,
  ListItem,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  VStack,
} from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import { MODAL_FOOTER_PB, MODAL_HEADER_PT } from '@/constants/mobileLayout';
import {
  RULES_DURING_TOURNAMENT_ANCHOR,
  SCORING_HELP_BULLETS,
  SCORING_HELP_FOOTER,
} from '@/constants/tournamentRulesCopy';
import { useMobileFormModal } from '@/hooks/useMobileFormModal';

export function TournamentScoringHelpModal(props: { isOpen: boolean; onClose: () => void }) {
  const { isOpen, onClose } = props;
  const { modalSize, isCentered, scrollBehavior, contentProps, footerPb } = useMobileFormModal();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      isCentered={isCentered}
      size={modalSize}
      scrollBehavior={scrollBehavior}
    >
      <ModalOverlay />
      <ModalContent {...contentProps}>
        <ModalHeader pt={MODAL_HEADER_PT} fontSize={{ base: 'lg', md: 'xl' }}>
          Points Calculation
        </ModalHeader>
        <ModalCloseButton mt={2} mr={2} />
        <ModalBody pb={footerPb}>
          <VStack align='stretch' spacing={4}>
            <List spacing={3} styleType='disc' pl={4} fontSize='sm'>
              {SCORING_HELP_BULLETS.map((line) => (
                <ListItem key={line}>{line}</ListItem>
              ))}
            </List>
            <Text fontSize='sm' color='gray.500'>
              {SCORING_HELP_FOOTER}
            </Text>
          </VStack>
        </ModalBody>
        <ModalFooter pb={footerPb} flexDirection='column' gap={2} alignItems='stretch'>
          <Button
            as={RouterLink}
            to={`/rules#${RULES_DURING_TOURNAMENT_ANCHOR}`}
            colorScheme='green'
            onClick={onClose}
          >
            Read full tournament rules
          </Button>
          <Button variant='ghost' onClick={onClose}>
            Close
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
